import { applyAsStep1 } from "../create/step1/config";
import { applyAsStep2 } from "../create/step2/config";
import {
  IApplicationBackEndModel,
  IApplicationFrontEndModel,
  IApplicationFrontEndModelStep1,
  IApplicationFrontEndModelStep2,
} from "../../types";
import { EducationType } from "../../../school/constants/types";

export function parseToApplicationBackEndModel(
  values: IApplicationFrontEndModel,
): IApplicationBackEndModel {
  const step1Name = applyAsStep1.stepName!;
  const step2Name = applyAsStep2.stepName!;
  const isHigherOrSecondary =
    values.injectedData.educationType === EducationType.Higher ||
    values.injectedData.educationType === EducationType.Secondary;

  const step1Values = values[step1Name] as IApplicationFrontEndModelStep1;
  const step2Values = values[step2Name] as
    | IApplicationFrontEndModelStep2
    | undefined;

  const applicationDocs = Object.entries(
    step2Values?.applicationFiles || {},
  ).map(([applicationFormId, uploadedFile]) => ({
    applicationFormId,
    fileId: uploadedFile.id,
  }));

  const extraDocs =
    values[step2Name]?.extraDocs?.map((i) => ({ fileId: i.id })) || [];

  const requiredDocs = Object.entries(step2Values?.requiredDocs || {}).map(
    ([requiredDocId, uploadedFile]) => ({
      requiredDocId,
      fileId: uploadedFile.id,
    }),
  );

  return isHigherOrSecondary
    ? {
        programId: values.injectedData.programId,
        studentId: step1Values.student!.id,
        branchId: step1Values.branch!.branchId,
        intakeId: step1Values.intake!.id,
        isLinkConfirmed: step2Values?.isLinkConfirmed || false,
        filledForms: applicationDocs,
        requiredDocs: requiredDocs,
        extraDocs: extraDocs,
        comment: step2Values?.comment || "",
      }
    : {
        courseId: values.injectedData.programId,
        studentId: step1Values.student!.id,
        branchId: step1Values.branch!.branchId,
        isLinkConfirmed: step2Values?.isLinkConfirmed || false,
        filledForms: applicationDocs,
        requiredDocs: requiredDocs,
        extraDocs: extraDocs,
        comment: step2Values?.comment || "",
      };
}
